import React from "react";
import { Grid, Typography, Box, List, ListItem, ListItemText } from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";

export default function ProductFeature() {
  return (

    <>
    <Grid container spacing={3} alignItems="center" justifyContent="center" padding={2}>
      
      {/* Left Side: Image/Mockup Section */}
      <Grid size={{ xs: 12, md: 6 }}>
        <Box sx={{p:5}}>
          <img src={imgUrl.productDashboardImg} className="w-100" />       
        </Box>
      </Grid>

      {/* Right Side: Text Section */}
      <Grid size={{ xs: 12, md: 6 }}>
        <Typography variant="h6" sx={{ color: "#6e1b9b ", fontWeight: "bold", mb: 2 }}>
          CASE BASED SURVEILLANCE
        </Typography>
        <Typography variant="body1" paragraph>
          Enhancing early detection and response through a unified surveillance system.
        </Typography>
        <List sx={{listStyle:'inherit'}}>
          <ListItem>
            <ListItemText primary="• Captures real-time health signals at the community level" />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Supports rapid outbreak response via a centralized command center" />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Triangulates data from human, animal, and environmental sources" />
          </ListItem>
        </List>
      </Grid>
    </Grid>

    <Box sx={{ backgroundColor: "#f5f5f5"}}>
      <Grid container spacing={4} alignItems="center">
        
        {/* Left Side: Circular Image */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Box>
            <img
              src={imgUrl.childDiabetesImg} 
              alt="Children smiling"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </Box>
        </Grid>

        {/* Right Side: Text */}
        <Grid size={{ xs: 12, md: 8 }}>
         
          <Box padding={4}>
                 <Typography
            variant="h6"
            sx={{ color: "#6e1b9b ", fontWeight: "bold", mb: 2 }}
          >
            CHILDHOOD TYPE 1 DIABETES
          </Typography>

          <Typography variant="body1" paragraph>
            Ministre de la Santé ublique et de la Prévention Triangulates data from human,
            animal, and environmental source segmentation de la connectivité internet
            grâce à des dispositifs internet portables
          </Typography>

          <Typography variant="body1">
            Ministre de la Santé ublique et de la Prévention Triangulates data from human,
            animal, and environmental source segmentation de la connectivité internet
            grâce à des dispositifs internet portables
          </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>

    <Box>
      <Grid container spacing={4} alignItems="center">
        
        {/* Left Side: Circular Image */}
         <Grid size={{ xs: 12, md: 8 }}>
         
          <Box padding={4}>
                 <Typography
            variant="h6"
            sx={{ color: "#6e1b9b ", fontWeight: "bold", mb: 2 }}
          >
            CASE BASED SURVEILLANCE
          </Typography>

          <Typography variant="body1" paragraph>
            Ministre de la Santé ublique et de la Prévention Triangulates data from human, animal, and environmental source 
            sugmentation de la connectivité internet grâce à des dispositifs internet portables
          </Typography>

          <Typography variant="body1">
            Ministre de la Santé ublique et de la Prévention Triangulates data from human, animal, 
            and environmental source sugmentation de la connectivité internet grâce à des dispositifs internet portables
          </Typography>
          </Box>
        </Grid>
       
        {/* Right Side: Text */}
         <Grid size={{ xs: 12, md: 4 }}>
          <Box>
            <img
              src={imgUrl.survelienceImg} 
              alt="survellience"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </Box>
        </Grid>

      </Grid>
    </Box>

    <Box sx={{ backgroundColor: "#f5f5f5"}}>
      <Grid container spacing={4} alignItems="center">
        
        {/* Left Side: Circular Image */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Box>
            <img
              src={imgUrl.communityImg} 
              alt="community"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </Box>
        </Grid>

        {/* Right Side: Text */}
        <Grid size={{ xs: 12, md: 8 }}>
         
          <Box padding={4}>
                 <Typography
            variant="h6"
            sx={{ color: "#6e1b9b ", fontWeight: "bold", mb: 2 }}
          >
            COMMUNITY LED MONITORING
          </Typography>

          <Typography variant="body1" paragraph>
           Ministre de la Santé ublique et de la Prévention Triangulates data from human, animal, and 
           environmental source sugmentation de la connectivité internet grâce à des dispositifs internet portables
          </Typography>

          <Typography variant="body1">
            Ministre de la Santé ublique et de la Prévention Triangulates data from human, animal, and environmental 
            source sugmentation de la connectivité internet grâce à des dispositifs internet portables
          </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
    </>
  );
}
